<template>
    <div class="m-menu">
        <div class="logo-wrapper">
            <router-link to="/rent/lease"><img class="logo" src="@/assets/imgs/common/logo.png" /></router-link>
        </div>
        <el-menu v-for="(paritem,index) in menuPar"
        class="menupar" background-color="#1D2B36"
      text-color="#747980" :index="index" :key="index"
      active-text-color="#fff"  @open="handleOpen" :defaultActive='defaultActive'
      @close="handleClose" :ref="'parmenu-'+index"  >
            <el-submenu :index="index+''" >
                <template slot="title" >
                    <i :class="paritem.icon?'iconfont '+paritem.icon:'iconfont icon-shouye1'"></i>
                <span class="menutitle" >{{paritem.name}}</span>
                </template>
                <el-menu-item v-for="(item,subindex) in paritem.menuList" :index="index+'-'+subindex" :key="subindex"  @click="toUrl(item.url,{index,subindex})" :class="(defaultActiveIndex.index === index && defaultActiveIndex.subindex === subindex)?'active':''">{{item.name}}</el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>
<style lang="scss" >
.is-opened .el-submenu__title{
           color:#fff;
            background:#1D2B36;
    }
.el-menu{
    .el-submenu__title{
        &:hover{
            color:#fff;
            background:#1D2B36;
        }
    }
}
 .el-submenu .el-menu{
        background:#0F1922!important;
        overflow: auto;
        .el-menu-item{
        &:hover,&.active{
        border-left:#3CBFC4 4px solid;
        padding-left:43px;
        color:#fff;
        background: #2A2D32;
        }
        color:#747980;
        padding-left:43px;
        border-left:#0F1922 4px solid;
        }
    }
</style>
<style lang="scss" scoped>
.m-menu{
position:absolute;
top:0;
bottom:0;
width:200px;
background:rgba(29,43,54,1);
text-align:center;
overflow: auto;
}
.menupar{
    background:rgba(29,43,54,1);
    &:hover{
    background:rgba(29,43,54,1);

    }
    color:#747980;
    text-align:left;
    .iconfont{
        font-size:17px
    }
    .menutitle{
        margin-left:10px;
        font-size:17px;
        border-radius:0;
    }
}
.logo-wrapper{
    line-height: 162px;
    .logo{
    width:90px;
    height:84px;
    margin:0 auto;
    vertical-align:middle;
    }
}

</style>
<script >
export default{
    name: 'Menu',
    data() {
        return {
            isCeo: false,
            hasSetDash: false,
            menuPar: this.$store.state.menu.menuPar,
            defaultActiveIndex: {index: 0, subindex: 0}, // 默认选中的是第几个
            defaultActive: ''                                  // 新面板导航默认打开项与路由对应枚举对应
        }
    },
    computed: {

    },
    methods: {
        //  跳转到不同地址 每次切换需要重置区域id
        toUrl(url, defaultActiveIndex) {
            // 清空区域id选项
            this.$store.commit('EMPTY_UNIT_IDS')
            this.defaultActiveIndex = defaultActiveIndex
            if (url.indexOf('dashboard') > -1) {
                const isProduction = location.hostname === 'ht.sayyoo.cn' || location.hostname === '120.55.42.62'
                let dashUrl = ''
                if (isProduction) {
                dashUrl = '//ht.sayyoo.cn/dashboard/'
                } else {
                dashUrl = '//h5test.sayyoo.cn/dashboard/'
                }
                window.open(dashUrl)
                return false
            } else {
                this.$router.push({path: url})
            }
        },

        handleOpen(index) {
        },
        handleClose(index) {
        },
        // 设置摊销查看权限
        setPowerOfReviewAmortize() {
           let roleData = this.$store.state.roleData
           let isInclude = roleData.includes('财务经理') || roleData.includes('会计') || roleData.includes('出纳')
           if (!isInclude) {
             this.menuPar = this.menuPar.filter(item => item.name !== '摊销管理')
           } else {
             return
           }

        },
        // 设置 绩效查看权限
        setPowerOfReviewPerformance() {
           let roleData = this.$store.state.roleData
           let isInclude = roleData.includes('运营部经理') || roleData.includes('公寓事业部经理') || roleData.includes('店长') || roleData.includes('小管家') || roleData.includes('人事主管')
           if (!isInclude) {
             this.menuPar = this.menuPar.filter(item => item.name !== '绩效')
           } else {
             return
           }
        }
    },
    created() {
        // 查询路由 得到应该正确渲染的焦点菜单 后续还需要判断正确展开的菜单
        let matched = this.$route.matched.filter(item => item.name)
        // 路由进行过滤 没有角色的没有这个菜单 添加适当延时，保证roleData 的准确获取
        setTimeout(() => {
            this.menuPar = this.menuPar.map((item, index) => {
            let roleData = this.$store.state.roleData
            if (item.basePath === '/house') {
                const roleList = ['小管家', '店长', '公寓事业部经理']
                // 空调数据 查看权限
               item.menuList = item.menuList.filter(menu =>
                     !(!(roleList.some(role => roleData.includes(role))) && menu.name === '空调数据')
                )
                return item
            }
            return item
          })
          // 摊销管理添加查看权限
          this.setPowerOfReviewAmortize()
          // 绩效添加查看权限
          this.setPowerOfReviewPerformance()
          // 设置菜单焦点
          this.menuPar.find((item, index) => {
            if (item.basePath === matched[0].path) {
                item.menuList.map((menuItem, subindex) => {
                    if (menuItem.url === matched[1].path) {
                        this.defaultActiveIndex = {index, subindex}
                        this.defaultActive = `${index}-${subindex}`
                    }
                })
            }
        })
        }, 500)
        // 报表查看权限
        // this.setPowerOfReviewReport()
        // 定时器查看角色
        this.isCeo = this.$store.state.roleData.indexOf('CEO') > -1

        },
    beforeDestroy() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Menu.vue